import React from "react"
import Header from "./Header"
import Footer from "./Footer"
import "./layoutstyles.css"

export default function Layout({ children }) {
    return (
      <div className="d-flex flex-column">
        <Header />
        <main className="pt-5">{children}</main>
        <Footer /> 
      </div>
    );
  }